import React, { useEffect, useRef, useState } from "react";

import emailjs from "emailjs-com";

import estilo from "./styles/Contacto.module.css";

import Titulo from "../components/Titulo";
import foto from "../img/rossBTV.jpg";
import MetaDecorator from "../utils/MetaDecorator";

function Contacto() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const form = useRef();

  const [texto, setTexto] = useState(false);
  const [mensaje, setMensaje] = useState("");

  const sendEmail = (e) => {
    e.preventDefault();
    setTexto(true);

    emailjs
      .sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        form.current,
        process.env.REACT_APP_EMAILJS_USER_ID
      )
      .then(
        (result) => {
          console.log(result.text);
          setTexto(false);
          setMensaje("Correo enviado con exito.");
        },
        (error) => {
          console.log(error.text);
          setTexto(false);
          setMensaje("Error al enviar correo.");
        }
      );
  };

  const [numero, setNumero] = useState("");

  const handleChange = (event) => {
    const value = event.target.value;
    if (value.length <= 9) {
      setNumero(value.replace(/[^0-9]/g, ""));
    }
  };

  let informacion = [
    {
      dato: "Bryan Roselbet Ticona Valencia",
      svg: (
        <svg width="24" height="24" viewBox="0 0 24 24">
          <path d="M7.5 6.5C7.5 8.981 9.519 11 12 11s4.5-2.019 4.5-4.5S14.481 2 12 2 7.5 4.019 7.5 6.5zM20 21h1v-1c0-3.859-3.141-7-7-7h-4c-3.86 0-7 3.141-7 7v1h17z"></path>
        </svg>
      ),
    },
    {
      dato: "bryan1736b@gmail.com",
      svg: (
        <svg width="24" height="24" viewBox="0 0 24 24">
          <path d="M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm0 2v.511l-8 6.223-8-6.222V6h16zM4 18V9.044l7.386 5.745a.994.994 0 0 0 1.228 0L20 9.044 20.002 18H4z"></path>
        </svg>
      ),
    },
    {
      dato: "+51 950 706 848",
      svg: (
        <svg width="24" height="24" viewBox="0 0 24 24">
          <path d="m20.487 17.14-4.065-3.696a1.001 1.001 0 0 0-1.391.043l-2.393 2.461c-.576-.11-1.734-.471-2.926-1.66-1.192-1.193-1.553-2.354-1.66-2.926l2.459-2.394a1 1 0 0 0 .043-1.391L6.859 3.513a1 1 0 0 0-1.391-.087l-2.17 1.861a1 1 0 0 0-.29.649c-.015.25-.301 6.172 4.291 10.766C11.305 20.707 16.323 21 17.705 21c.202 0 .326-.006.359-.008a.992.992 0 0 0 .648-.291l1.86-2.171a.997.997 0 0 0-.085-1.39z"></path>
        </svg>
      ),
    },
    {
      dato: "Lima, Perú",
      svg: (
        <svg width="24" height="24" viewBox="0 0 16 16">
          <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z" />
        </svg>
      ),
    },
  ];

  return (
    <div className={estilo.contacto}>
      <MetaDecorator
        titulo={"Contacto"}
        subtitulo={"Contacto"}
        descripcion={
          "Si estás interesado/a en trabajar conmigo o simplemente deseas comunicarte conmigo para cualquier otra consulta, no dudes en ponerte en contacto a través de esta sección. Estoy siempre dispuesto/a a escuchar tus ideas y necesidades, y a colaborar contigo para llevar a cabo proyectos exitosos. Puedes utilizar el formulario de contacto para enviarme un mensaje directamente, o si prefieres, puedes comunicarte conmigo por correo electrónico o por teléfono. Estaré encantado/a de responder cualquier pregunta que tengas y de proporcionarte la información que necesites. ¡No dudes en contactarme para empezar a trabajar juntos!."
        }
        url={"https://bryanticonavalencia.site/contacto"}
        canonical={"https://bryanticonavalencia.site/contacto"}
      ></MetaDecorator>

      <Titulo
        titulo="Contacto"
        descripcion="Muestrame tus ideas y trabajemos juntos en hacerlas realidad."
      ></Titulo>

      <div className={estilo.contenido_contacto}>
        <div className={estilo.perfil}>
          <div className={estilo.foto}>
            <img src={foto} alt="foto" />
          </div>

          <div className={estilo.datos}>
            {informacion.map((e, i) => (
              <p key={i}>
                {e.svg} {e.dato}
              </p>
            ))}
          </div>
        </div>

        <form ref={form} onSubmit={sendEmail}>
          <div className={estilo.subtitulo}>
            <h3>Contáctame</h3>
            <p>
              Completa el formulario que aparece a continuación y te respondere
              lo más antes posible.
            </p>
          </div>

          <div className={estilo.datos_form}>
            <label>Nombre:</label>
            <input type="text" name="name" required />
          </div>

          <div className={estilo.datos_form}>
            <label>Teléfono:</label>
            <input
              type="tel"
              name="phone"
              required
              value={numero}
              onChange={handleChange}
            />
          </div>

          <div className={estilo.datos_form}>
            <label>Correo:</label>
            <input type="email" name="email" required />
          </div>

          <div className={estilo.datos_form}>
            <label>Mensaje:</label>
            <textarea name="message" required />
          </div>

          <input
            className={estilo.boton_enviar}
            type="submit"
            value={texto ? "ENVIANDO" : "ENVIAR"}
          />
          {mensaje && <p>{mensaje}</p>}
        </form>
      </div>
    </div>
  );
}

export default Contacto;
